import { render, staticRenderFns } from "./liability-information.vue?vue&type=template&id=41a66356&scoped=true"
import script from "./liability-information.vue?vue&type=script&lang=ts"
export * from "./liability-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a66356",
  null
  
)

export default component.exports